import {contains, union} from "./Utils/ArrayUtils";
import {getItemTypesByName, ITEM_SUB_TYPES_WITHOUT_STATS} from "./enums/D4Enums";
import {convertUtcSecondsToDate} from "./Utils/DateUtils";

const adjustItemInAuctionForGui = function(auction) {
    if(auction.item === undefined || auction.item === null) {
        return;
    }

    auction.itemType = auction.item.type
    auction.itemSubType = auction.item.subType
    auction.itemName = auction.item.name
    auction.itemTitle = auction.item.title
    auction.itemPower = auction.item.itemPower
    auction.levelRequirement = auction.item.levelRequirement
    auction.classRequirement = auction.item.classRequirement
    auction.dps = auction.item.dps
    auction.armor = auction.item.armor
    auction.allResist = auction.item.allResist
    auction.rarity = auction.item.rarity
    if(auction.item.basicStats) {
        auction.item.basicStats.forEach(stat => {
            auction[stat.name] = stat.floatValues[0];
        })
    }
    if(auction.item.stats) {
        auction.item.stats.forEach(stat => {
            auction[stat.name] = stat.floatValues[0];
        })
    }

    if(auction.item.specialStats) {
        auction.item.aspects = []
        auction.item.uniqueAffixes = []
        auction.item.setAffixes = []
        auction.item.mythicAffixes = []

        auction.item.specialStats.forEach(stat => {
            if(stat.aspect) {
                auction[stat.name] = stat.floatValues[0];
                auction.item.aspects.push(stat)
            }
            if(stat.unique) {
                auction[stat.name] = stat.floatValues[0];
                auction.item.uniqueAffixes.push(stat)
            }
            if(stat.set) {
                auction[stat.name] = stat.floatValues[0];
                auction.item.setAffixes.push(stat)
            }
            if(stat.mythic) {
                auction[stat.name] = stat.floatValues[0];
                auction.item.mythicAffixes.push(stat)
            }
        })
    }
}

export const adjustItemFromRekognitionForGui=function(d4Item) {
    if (!d4Item.itemPower) {
        d4Item.itemPower = 0;
    }

    if (!d4Item.dps) {
        d4Item.dps = 0;
    }

    if (!d4Item.levelRequirement) {
        d4Item.levelRequirement = 0;
    }

    if (!d4Item.armor) {
        d4Item.armor = 0;
    }

    if (!d4Item.allResist) {
        d4Item.allResist = 0;
    }

    if(d4Item.specialStats) {
        d4Item.aspects = []
        d4Item.uniqueAffixes = []
        d4Item.setAffixes = []
        d4Item.mythicAffixes = []

        d4Item.specialStats.forEach(stat => {
            if(stat.aspect) {
                d4Item.aspects.push(stat)
            }
            if(stat.unique) {
                d4Item.uniqueAffixes.push(stat)
            }
            if(stat.set) {
                d4Item.setAffixes.push(stat)
            }
            if(stat.mythic) {
                d4Item.mythicAffixes.push(stat)
            }
        })
    }

    if (d4Item.name) {
        if (d4Item.type) {
            //nothing to do
        } else {
            //we have to search for the type because the backend item recognition mostly does not set type/subtype
            // for now
            let typeObjects = getItemTypesByName(d4Item.name);
            if (typeObjects) {
                d4Item.type = typeObjects[0].itemType
                d4Item.subType = typeObjects[0].itemSubType

                if (typeObjects.length > 1) {
                    //we switch the 2h type to 1h type because we should detect 2h type from backend
                    if (d4Item.subType === "Two-Handed") {
                        d4Item.subType = "One-Handed";
                    }
                }
            }
        }
    }

    return d4Item;
}

const adjustDatesInAuctionForGui=function(auction) {
    auction.creationDate = convertUtcSecondsToDate(auction.creationDate);
    auction.expirationDate = convertUtcSecondsToDate(auction.expirationDate);

    if(auction.abortionDate) {
        auction.abortionDate = convertUtcSecondsToDate(auction.abortionDate);
    }
}

export const auctionToTableElement = function (auction) {
    let result = auction

    // result.region = "ALL"

    adjustDatesInAuctionForGui(result);
    adjustItemInAuctionForGui(result);

    result.pricePerItem = auction.amount ? auction.price / auction.amount : auction.price
    return result;
}

export const bidsForMyAuction = function(bids, setAlert) {
    let result = [];

    for (let i = 0; i < bids.length; i++) {
        let resultBid = bids[i]
        if(resultBid == null) {
            setAlert(["warning", "Cannot find bid for a bidder - please report a bug"]);
        } else {
            resultBid.id = resultBid.bidder + resultBid.auctionId
            resultBid.pricePerItem = resultBid.amount ? resultBid.price / resultBid.amount : resultBid.price
            result.push(resultBid)
        }
    }

    return result;
}

export const myAuctionsAndBidsToMyBids = function(auctions, bids, bidStatusFilter) {
    let result = [];
    for (let i = 0; i < auctions.length; i++) {
        let bid = bids[i];
        if(contains(bidStatusFilter, bid.status)) {
            let temp = auctions[i]

            adjustDatesInAuctionForGui(temp);
            adjustItemInAuctionForGui(temp)

            temp.myBidStatus = bid.status
            temp.bidder = bid.bidder
            if(bid.currency) {
                temp.originalCurrency = temp.currency;
                temp.originalPrice = temp.price;
                temp.originalAmount = temp.amount;
                temp.originalPricePerItem = temp.amount ? temp.price / temp.amount : temp.price

                temp.currency = bid.currency;
                temp.price = bid.price;
                temp.amount = bid.amount;
            }

            temp.pricePerItem = temp.amount ? temp.price / temp.amount : temp.price
            result.push(temp)
        }
    }
    return result;
}

export const convertToD4ItemForRequest = function(baseItem, baseStats, implicitStatsToConvert, affixStats, aspects, uniqueAffixes, setAffixes, mythicAffixes, game) {
    let specialStats = !contains(ITEM_SUB_TYPES_WITHOUT_STATS, baseItem.itemSubType) ?
        union(getStats(aspects, true, false, false, false),
            getStats(uniqueAffixes, false, true, false, false),
            getStats(setAffixes, false, false, true, false),
            getStats(mythicAffixes, false, false, false, true)
        ) : [];

    return {
        //the json requests need some additional information for java lambda functions to identify generic types
        // e.g. base type ist BaseItem and real class is e.g. D4Item
        game: game,

        type: baseItem.itemType,
        subType: baseItem.itemSubType,
        title: baseItem.title,
        name: baseItem.name,
        rarity: baseItem.rarity,
        basicStats: !contains(ITEM_SUB_TYPES_WITHOUT_STATS, baseItem.itemSubType) && implicitStatsToConvert ? getStats(implicitStatsToConvert) : [],
        stats: !contains(ITEM_SUB_TYPES_WITHOUT_STATS, baseItem.itemSubType) && affixStats ? getStats(affixStats) : [],
        specialStats: specialStats,
        itemPower : baseStats.itemPower,
        classRequirement: baseStats.classRequirement,
        levelRequirement: baseStats.levelRequirement,
        dps: baseStats.dps && baseStats.dps > 0 ? baseStats.dps : null,
        armor: baseStats.armor && baseStats.armor > 0 ? baseStats.armor : null,
        allResist: baseStats.allResist && baseStats.allResist > 0 ? baseStats.allResist : null,
    }
}

const getStats = function(statsToConvert, isAspect, isUnique, isSet, isMythic) {
    if(!statsToConvert) {
        return statsToConvert;
    }

    let result = Object.assign([], statsToConvert);
    result.map(stat => {
        if(!stat.floatValues || !stat.floatValues[0]) {
            stat.floatValues = [0];
        }
        if(isAspect) {
            stat.aspect = true;
        }
        if(isUnique) {
            stat.unique = true;
        }
        if(isSet) {
            stat.set = true;
        }
        if(isMythic) {
            stat.mythic = true;
        }
        return stat;
    })
    return result;
}